<template>
  <div class="k-v-panel" :class="{'bottom-line': showBottomLine}">
    <div class="k-v-panel-key">
      {{label}}：
    </div>
    <div class="k-v-panel-value">
      <div class="k-v-panel-body">
        <slot>{{value}}</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KVPanel',
  props: {
    label: String,
    value: {},
    // 无value时隐藏
    hideWhenNoValue: {
      type: Boolean,
      default: true
    },
    showBottomLine: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .k-v-panel
    position relative
    display flex
    box-sizing border-box
    // padding 10px 16px
    padding 10px 0px
    overflow hidden
    width 100%
    font-size 14px
    &-key
      flex none
      box-sizing border-box
      margin-right 6px
      width 75px
      color #969799
      text-align left
    &-value
      flex 1
      position relative
      overflow hidden
      color #646566
      vertical-align middle
    &-body
      display flex
      align-items center
    .bottom-line::after
      position absolute
      box-sizing border-box
      content ' '
      pointer-events none
      // left 16px
      // right 16px
      left 0px
      right 0px
      bottom 0
      border-bottom 1px solid #ebedf0
      transform scaleY(.5)
</style>